import { createFileRoute, redirect } from '@tanstack/react-router';

/** Settings opens on the company: the first thing a new admin does is add colleagues, not read the bill. */
export const Route = createFileRoute('/t/$tenant/settings/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/t/$tenant/settings/company/general',
      params: { tenant: params.tenant },
      replace: true,
    });
  },
});
